import { UPDATE_SEARCHDATA_NHANVAY } from "../../actions/NhanVay/actionTypes";

const initialState = {
  customerName: "",
  phone: "",
  dateFrom: "",
  dateTo: "",
  status: 1,
  pageIndex: 1,
  pageSize: 20,
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchNhanVay = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHDATA_NHANVAY:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchNhanVay;
